
import * as types from "../action/types";

const initialState = {
  loading: false,
  alert: false,
  hasFailedLogin: false,
  products: [],
  validProducts: [],
  scheduledProducts: [],
};

const products = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.GET_ALL_PRODUCTS:
      return {
        ...state,
        products: payload,  // Store products in Redux state
      };

    case types.GET_ALL_SCHEDULED_PRODUCTS:
      return {
        ...state,
        scheduledProducts: payload,  // Store scheduled products in Redux state
      };

    case types.GET_VALID_PRODUCTS:
      return {
        ...state,
        validProducts: payload,  // Store valid products in Redux state
      };

    default:
      return state;
  }
};

export default products;
